import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, signal, viewChild, viewChildren, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageItem } from '@components/partials/page-item/page-item';
import { UiModule } from '@components/ui/ui-module';
import { Page, Scan, UserBinder } from '@models/binder.model';
import { BinderService } from '@services/binder.service';
import { Router } from '@services/route.service';
import { ScannerService } from '@services/scanner.service';
import { User } from '@services/user.service';

@Component({
  selector: 'lgb-binder-page-list',
  imports: [
    CommonModule,
    UiModule,
    PageItem
  ],
  templateUrl: './binder-page-list.html',
  styleUrl: './binder-page-list.css',
})
export class BinderPageList {
  readonly carousel=viewChild.required<ElementRef<HTMLElement>>('modalCaroussel');
  readonly slides=viewChildren<ElementRef<HTMLElement>>('carouselItem');
  readonly dialog=viewChild.required<ElementRef<HTMLDialogElement>>('dlg');

  //service
  readonly scanService=inject(ScannerService);
  readonly binderS=inject(BinderService);
  readonly route=inject(ActivatedRoute);
  readonly router=inject(Router);

  //data
  readonly uBinder=input.required<UserBinder>();
  readonly pages=input.required<Page[]>();
  readonly scans=input.required<Scan[]>();
  readonly admin=input(true);

  //ui
  readonly opened=signal(false);
  readonly fragment=signal<string>(null);

  constructor(){
    this.route.fragment.subscribe(f => this.fragment.set(f));
  }

  getImgPage(page: Page){
    return this.binderS.getImgPage(page, this.getScanPage(page.scan));
  }

  isFinish(page: Page){
    const scan=this.getScanPage(page.scan);
    return (scan && scan.state=='finished');
  }

  getScanPage(ident: string){
    return this.scans().find(s => s.ident==ident);
  }

  openDialog(i: number){
    this.opened.set(true);
    this.dialog().nativeElement.showModal();
    this.goTo(i);
  }
  
  goTo(i: number) {
    const el=this.slides().at(i)?.nativeElement;
    if(el)
      el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  toggleFavoritePage(page: Page){
    this.binderS.toggleFavoritePage(page.ident)
      .subscribe(p => page.isFavorite=p.isFavorite);
  }
}
